import type { SVGProps } from "react";
const SuiTriangleDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 15"
    {...props}
  >
    <path fill="currentColor" d="m0 0 11.994 15L24 0z" />
  </svg>
);
export default SuiTriangleDownIcon;
